module.exports = __webpack_public_path__ + "static/media/ic-coachingsteps-bg.45cc69f3.png";